import React, { useCallback } from 'react';
import './Tabs.less';
import classNames from 'classnames';

export interface ITabsProps {
  className?: string;
  onTabSelected: (value: string) => void;
  tabs: ITab[];
  currentValue?: string | null;
  renderTab?: (tab: ITab, isCurrent: boolean) => React.ReactNode | null;
}

export interface ITab {
  value: string;
  label?: string;
  className?: string;
  disabled?: boolean;
}

function getTabClassName(isCurrent: boolean, isDisabled?: boolean) {
  return classNames('dpc-tabs__tab', {
    'dpc-tabs__tab--current': isCurrent,
    'dpc-tabs__tab--disabled': isDisabled,
  });
}

function getTabButtonName(isCurrent: boolean, className?: string) {
  return classNames('dpc-tabs__button', className, {
    'dpc-tabs__button--current': isCurrent,
  });
}

export function Tabs({ className, tabs, onTabSelected, currentValue, renderTab }: ITabsProps) {
  const getTab = useCallback(
    (tab: ITab) => {
      const isCurrent = currentValue === tab.value && !tab.disabled;

      return (
        <li
          key={tab.value}
          className={getTabClassName(isCurrent, tab.disabled)}
          onClick={() => {
            onTabSelected(tab.value);
          }}
        >
          {renderTab && renderTab(tab, isCurrent)}
          {renderTab == null && (
            <button className={getTabButtonName(isCurrent, tab.className)} title={tab.label} disabled={tab.disabled}>
              {tab.label}
            </button>
          )}
        </li>
      );
    },
    [currentValue, renderTab, onTabSelected]
  );

  return <ul className={classNames('dpc-tabs', className)}>{tabs.map(t => getTab(t))}</ul>;
}
